export default {
    'fr': 'Français',
    'en': 'English' 
}